import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import PatientPortalShell from '../components/PatientPortalShell';
import ReferralRequestForm from '../components/ReferralRequestForm';
import { referralPortalApi } from '../api/referralPortal.api';

export default function PatientReferralNewPage() {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  const [catalogue, setCatalogue] = useState(null);
  const [workflow, setWorkflow] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      referralPortalApi.me(),
      referralPortalApi.specialisations(),
      referralPortalApi.approvalWorkflow().catch(() => null),
    ])
      .then(([m, c, w]) => { setMe(m); setCatalogue(c); setWorkflow(w); })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#F8F4F0]">
        <Loader2 className="h-8 w-8 animate-spin text-orange-600" />
      </div>
    );
  }

  return (
    <PatientPortalShell branding={me?.tenant?.branding} tenantName={me?.tenant?.name}>
      <div className="mb-6">
        <h2 className="font-heading text-3xl text-stone-900">New referral request</h2>
        <p className="mt-1 text-sm text-stone-500">
          Complete patient details, destination hospital, and station type.
        </p>
      </div>
      <ReferralRequestForm
        me={me}
        catalogue={catalogue}
        workflow={workflow}
        onCreated={(created) => navigate(`/patient/referrals/${created.id}`)}
      />
    </PatientPortalShell>
  );
}
